import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

// text,email,tel,textarea,password, 
@Component({
    selector: 'text-area',
    template: `
      <div [formGroup]="form">
        <textarea [class.is-invalid]="isDirty && !isValid" [formControlName]="field.name" [id]="field.name"
        rows="9" class="form-control"></textarea>
      </div> 
    `
})
export class TextAreaComponent {
    @Input() field:any = {};
    @Input() form:FormGroup;
    get isValid() { return this.form.controls[this.field.name]?.valid; }
    get isDirty() { return this.form.controls[this.field.name]?.dirty; }
  
    constructor() {

    }
}